import React from 'react';

/** Slash-separated breadcrumb; the last item renders as the current screen. */
export default function Breadcrumb({ items = [], className = '' }) {
  return (
    <div className={`ui-breadcrumb ${className}`.trim()}>
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && ' / '}
            <span className={isLast ? 'ui-breadcrumb__current' : ''}>{item}</span>
          </React.Fragment>
        );
      })}
    </div>
  );
}
